import css from "styled-jsx/css";

const staticStyles = css.global`
  @import "src/common/styling/_mixins-scss/screen-size";
  @import "src/common/styling/_mixins-scss/vars";
  @import "src/common/styling/_mixins-scss/rem";

  .AccountPage__table {
    margin-top: rem(25px);
    @include respond-to(sm) {
      margin-top: rem(10px);
    }
    :global(.NoItemsPanel) {
      box-shadow: 0 1px 6px 1px rgba(0, 0, 0, 0.06);
      height: rem(200px) !important;
      min-height: auto !important;
      img {
        margin-bottom: rem(15px) !important;
      }
      h3 {
        font-size: rem(16px) !important;
        margin-bottom: 0 !important;
      }
    }
  }

  .AccountPage__top-line {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    min-height: 50px;
    @include respond-to(sm) {
      min-height: 54px;
    }
    .PageTabs {
      width: auto;

      a {
        padding-left: 0;
      }

      @include respond-to(sm) {
        order: 0;
        margin-bottom: 15px;
      }
    }
  }

  .AccountPage__date {
    display: flex;
    align-items: center;
    gap: 10px;
    @include respond-to(xs) {
      width: 100%;
      order: 1;
    }
  }

  .AccountPage__calendar-label {
    font-size: rem(14px);
    font-weight: 500;
    color: #333;
    white-space: nowrap;
    margin-bottom: 10px;
  }

  @media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {
    .AccountPage__table {
      :global(.NoItemsPanel) {
        :global(img) {
          width: 100px !important;
        }
      }
    }
  }
`;

const getDynamicStyles = ({ colors, border }) => {
  return css.global`
    .AccountPage__table {
      .NoItemsPanel {
        background-color: ${colors.white.hex};
        border-radius: ${border.radius};
      }
    }
  `;
};

export { staticStyles, getDynamicStyles };
